declare const swal: any;
export class UiActionUtils {
     static confirmDelete(message: string, onConfirm: () => void): void {
    swal({
      title: 'Are you sure to delete?',
      text: message || 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'YES, Delete IT!'
    }).then((result) => {
      if (result?.value === true) {
        onConfirm();
      }
    });
  }

  static confirmUpdate(message: string, onConfirm: () => void): void {
  swal({
    title: 'Are you sure?',
    text: message || 'You won\'t be able to revert this!',
    type: 'warning',
    showCancelButton: true,
    confirmButtonClass: 'btn btn-success',
    cancelButtonClass: 'btn btn-danger',
    confirmButtonText: 'YES, Update IT!'
  }).then((result) => {
    if (result === true || result?.value === true) {
      onConfirm();
    }
  });
}

static confirmWithRemarks(
  htmlMessage: string,
  onConfirm: (remarks: string) => void
): void {
  swal({
    title: '',
    html:
      htmlMessage +
      '<input id="swal-input" class="swal2-input" placeholder="Enter your delete remarks">' +
      '<p id="error-message" style="color: red; display: none;">Please enter some remarks.</p>' +
      '<p id="length-message" style="color: red; display: none;">Please enter max. 100 characters as remarks.</p>',
    showCancelButton: true,
    confirmButtonText: 'OK',
    confirmButtonClass: 'btn btn-success',
    cancelButtonClass: 'btn btn-danger',
    allowOutsideClick: false,
    preConfirm: () => {
      return new Promise<{ value: string }>((resolve, reject) => {
        const input = document.getElementById('swal-input') as HTMLInputElement;
        const value = input?.value.trim();
        const errorMsg = document.getElementById('error-message');
        const lengthMsg = document.getElementById('length-message');

        if (errorMsg) errorMsg.style.display = 'none';
        if (lengthMsg) lengthMsg.style.display = 'none';

        if (!value) {
          if (errorMsg) errorMsg.style.display = 'block';
          reject(new Error('Remarks are required'));
        } else if (value.length > 100) {
          if (lengthMsg) lengthMsg.style.display = 'block';
          reject(new Error('Remarks too long'));
        } else {
          resolve({ value }); // ✅ Wrap in object
        }
      });
    }
  }).then((result) => {
    if (result?.value) {
      onConfirm(result.value);
    } else {
      console.log("Dialog was canceled or no value");
    }
  });
}


   static showSuccess(message: string): void {
    swal({
      title: '',
      text: message,
      type: 'success',
      confirmButtonClass: 'btn btn-info'
    });
  }

   static showError(message: string, additionalMessage?: string): void {
    swal({
      title: '',
      text: `${message}${additionalMessage ? '\n' + additionalMessage : ''}`,
      type: 'error',
      confirmButtonClass: 'btn btn-info'
    });
  }

}
